import Vue from "vue";
import "./plugins/element.js";
import App from "./view/App.vue";
import "./assets/style/global.scss";
import "./assets/style/mobile.scss";
import SvgIcon from "./components/Svg/index.vue";
import router from './router';


import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
import 'swiper/swiper.css'
Vue.use(VueAwesomeSwiper)

// 导入svg
Vue.component("svg-icon", SvgIcon);

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);

const req = require.context("@/assets/img/svg", true, /\.svg$/);
requireAll(req);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
